
/*
* 课程中心
*/

<template>
  <div class="hbn-container" id="Course">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="标题">
                  <el-input
                    id="title"
                    v-model="PageQuery.queryModel.title"
                    placeholder="标题"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-show="false">
                <el-form-item label="分类">
                  <el-input
                    id="courseCategoryId"
                    v-model="PageQuery.queryModel.courseCategoryId"
                    placeholder="分类"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="讲师">
                  <el-select
                    v-model="PageQuery.queryModel.teacherIds"
                    multiple
                    value-key="id"
                    collapse-tags
                    @change="selectTeacherChange"
                  >
                    <el-option
                      v-for="(item) in teachers"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="CourseEdit(-1, 'Add')"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button
          class="custom-button"
          type="primary"
          style="width: 6rem"
          @click="BatchDel"
        >
          <i class="el-icon-delete custom-icon"></i>
          <span>批量删除</span>
        </el-button>

        <el-button
          v-show="false"
          type="primary"
          class="custom-button"
          @click="importExcel"
        >
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button
          type="primary"
          class="custom-button"
          @click="export2Excel"
        >
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
            :checkbox-config="tableCheckboxConfig"
          >
            >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in CourseList" :key="key">
              <vxe-table-column
                v-if="item.isShow"
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="200"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex, row }">
                <el-button
                  v-show="row.status != 1"
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Modify')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                  >查看</el-button
                >
                <el-button
                  v-show="row.status != 1"
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Delete')"
                  >删除</el-button
                >
                <!-- <el-popconfirm
                  title="是否要删除?"
                  @confirm="handleClick(rowIndex, 'Delete')"
                >
                  <template #reference>
                    <el-button size="small" type="text">删除</el-button>
                  </template>
                </el-popconfirm> -->
                <el-button
                  v-show="row.status != 1"
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Audit')"
                  >审核</el-button
                >
                <el-button
                  v-show="row.status == 1"
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'TakeDown')"
                  >下架</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <!-- <template #left>
                    <span class="page-left">
                        <span>已选中 {{ checkendSum }}</span>
                        <span class="clear" @click.prevent="$refs.multipleTable.clearCheckboxRow()">清空</span>
                    </span>
                </template> -->
          </vxe-pager>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <CourseEdit
      ref="CourseEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></CourseEdit>
    <excel
      ref="industrialUnitExcel"
      :importurl="importurl"
      fileName="所属行业.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { CourseList } from "@/assets/apiData/CourseList";
import {
  GetDataCourseListByPageQuery,
  DeleteCourse,
  ModifyCourse,
  DeleteCourses,
} from "@api/ApiCourse";
import {GetDataTeacherList} from "@api/Course/ApiTeacher"
import CourseEdit from "@comp/Course/CourseEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
// import XEUtils from "xe-utils";
import { ElMessageBox } from "element-plus";
import { dateFormat } from "@/util/utils.js";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
          teacherIds:[]
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Industry: {
        CodeID: "",
        Name: "",
      },
      CourseList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=Industry",
      tableCheckboxConfig: {
        checkMethod: ({ row }) => {
          return row.status != 1;
        },
      },
      teachers: [],
    };
  },
  components: {
    CourseEdit,
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    selectTeacherChange(val) {
      this.PageQuery.queryModel.teacherIds = val
    },
    //加载讲师
    loadTeachers(){
      let _this = this
      GetDataTeacherList({
        queryModel: {},
        pageindex: 1,
        PageSize: 10000,
      }).then(res=>{
        _this.teachers = res.entities
      })
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "type":
          cellValue =
            cellValue == "0"
              ? "平台公开"
              : cellValue == "1"
              ? "企业公开"
              : "自定义";
          break;
        case "status":
          cellValue =
            cellValue == "0"
              ? "已创建"
              : cellValue == "1"
              ? "已审核"
              : "已下架";
          break;
        case "isGoodClass":
          cellValue = cellValue ? "是" : "否";
          break;
      }
      return cellValue;
    },
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      //this.url="/api/IndustrialUnit/ImportExcel";
      this.UpLoaddialogVisible = true;
    },
    export2Excel() {
      const v = this;
      v.loading = true;
      GetDataCourseListByPageQuery(JSON.stringify({
        ...v.PageQuery,
        ...{
          PageSize: v.total,
        },
      })).then(function (res) {
        v.loading = false;
        require.ensure([], () => {
          const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径
          const tHeader = [
            ...Enumerable.from(v.CourseList)
              .select((item) => {
                return item.label;
              })
              .toArray(),
          ]; // 标题
          const filterVal = [
            ...Enumerable.from(v.CourseList)
              .select((item) => {
                return {
                  prop: item.prop,
                  format: item.format
                };
              })
              .toArray(),
          ]; // 导出的字段名
          const list = res.entities;
          const data = v.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, `课程中心`);
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => {
        return filterVal.map((j) => {
          let format = j.format;
          let cellValue = v[j.prop]
          switch (format) {
            case "datetime":
              cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
              break;
            case "type":
              cellValue =
                cellValue == "0"
                  ? "平台公开"
                  : cellValue == "1"
                  ? "企业公开"
                  : "自定义";
              break;
            case "status":
              cellValue =
                cellValue == "0"
                  ? "已创建"
                  : cellValue == "1"
                  ? "已审核"
                  : "已下架";
              break;
            case "isGoodClass":
              cellValue = cellValue ? "是" : "否";
              break;
          }
          return cellValue;
        })
      });
    },
    handleClick(index, type) {
      console.log(index, type);

      this.CourseEdit(index, type);
    },
    CourseEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        ElMessageBox.confirm(`是否要删除?`, "提示", {
          cancelButtonClass: "cancelstyle",
          confirmButtonClass: "confirmstyle",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            DeleteCourse(this.DataList[index].id).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
                _this.PageQuery.pageindex = 1;
                _this.GetData();
              }
            });
          })
          .catch(() => {
            return;
          });
      } else if (type == "Audit") {
        // 审核
        ElMessageBox.confirm(`是否要审核?`, "提示", {
          cancelButtonClass: "cancelstyle",
          confirmButtonClass: "confirmstyle",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            let row = this.DataList[index];
            row.status = 1;
            ModifyCourse(row)
              .then(function (data) {
                if (data) {
                  _this.$message.success("审核成功");
                  _this.PageQuery.pageindex = 1;
                  _this.GetData();
                }
              })
              .catch((message) => {
                _this.$message.error(message);
              });
          })
          .catch(() => {
            return;
          });
      } else if (type == "TakeDown") {
        // 下架
        ElMessageBox.confirm(`是否要下架?`, "提示", {
          cancelButtonClass: "cancelstyle",
          confirmButtonClass: "confirmstyle",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            let row = this.DataList[index];
            row.status = 2;
            ModifyCourse(row)
              .then(function (data) {
                if (data) {
                  _this.$message.success("下架成功");
                  _this.PageQuery.pageindex = 1;
                  _this.GetData();
                }
              })
              .catch((message) => {
                _this.$message.error(message);
              });
          })
          .catch(() => {
            return;
          });
      } else {
        this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.CourseEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange({ records }) {
      this.multipleSelection = records;
    },
    //全选
    selectAllChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange({ row }) {
      console.log(val);
      this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataCourseListByPageQuery(JSON.stringify(this.PageQuery)).then(
          function (data) {
            _this.DataList = data.entities;
            _this.total = data.totalCount;
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    //批量删除
    BatchDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要删除的课程");
        return;
      }
      this.$confirm(`确定删除？`, "提示", {
        cancelButtonClass: "cancelstyle",
        confirmButtonClass: "confirmstyle",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          let courseIds = Enumerable.from(this.multipleSelection)
            .select((ss) => ss.id)
            .toArray();
          DeleteCourses(courseIds)
            .then((res) => {
              this.$message.success("批量删除成功");
              this.GetData();
            })
            .catch((message) => {
              this.$message.error(message);
            });
        })
        .catch(() => {
          return;
        });
    },
  },
  created() {
    this.CourseList = CourseList;
    this.GetData();
    this.loadTeachers();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
